import axios from 'axios'
import { config } from '../Config/config'

const userService ={
    getAll : () => {
        const result = axios.get(config.apiUrl + '/user')
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    cekEmail : (email) =>{
        const result = axios.get(config.apiUrl + '/user/'+ email)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result[0]
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    lastLogin: (data) =>{
        const result=axios.put(config.apiUrl + '/updatelastlogin',data)
        .then(respon =>{
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    Loginatt: (data) =>{
        const result=axios.put(config.apiUrl + '/loginatt',data)
        .then(respon =>{
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    sendOtp: (data) =>{
        const result=axios.post(config.apiUrl + '/sendOTP',data)
        .then(respon =>{
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    getRole : () => {
        const result = axios.get(config.apiUrl + '/role')
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    addDataBio: (data) =>{
        const result=axios.post(config.apiUrl + '/biodata',data)
        .then(respon =>{
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    addData: (data) =>{
        const result=axios.post(config.apiUrl + '/user',data)
        .then(respon =>{
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    resetPassword: (data) =>{
        const result=axios.put(config.apiUrl + '/resetpassword',data)
        .then(respon =>{
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    resetPasswordlog: (data) =>{
        const result=axios.post(config.apiUrl + '/resetpasslog',data)
        .then(respon =>{
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    getOldpass : (user_id) => {
        const result = axios.get(config.apiUrl + '/resetpass/' + user_id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    insertToken: (data) =>{
        const result=axios.post(config.apiUrl + '/token',data)
        .then(respon =>{
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    expToken: (data) =>{
        const result=axios.put(config.apiUrl + '/expToken',data)
        .then(respon =>{
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    lockUser: (data) =>{
        const result=axios.put(config.apiUrl + '/locked_user',data)
        .then(respon =>{
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    listExpToken : (email) => {
        const result = axios.get(config.apiUrl + '/Listexptoken/' + email)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    }


}

export default userService